import useComponentSize from '@rehooks/component-size';
import moment from 'moment';
import * as React from 'react';

import { CELL_SPACING, CELL_WIDTH } from '../../../../constants';

export const useAbsenceCalendar = () => {
  const containerRef = React.useRef<HTMLTableElement>(null);
  const { width: calendarWidth } = useComponentSize(containerRef);

  const numberOfDaysInView = Math.floor(
    calendarWidth / (CELL_WIDTH + CELL_SPACING),
  );
  const [viewStartDate, setViewStartDate] = React.useState(moment());

  const endOfRange = moment().add(30, 'days');

  const handleCalendarNavigation = (direction: string) => {
    if (direction === 'LEFT') {
      setViewStartDate(
        moment.max(
          moment(),
          viewStartDate.clone().subtract(numberOfDaysInView - 1, 'days'),
        ),
      );
    } else {
      setViewStartDate(
        viewStartDate.clone().add(numberOfDaysInView - 1, 'days'),
      );
    }
  };

  const daysInView = React.useMemo(() => {
    const currentDaysInView = [];
    for (let i = 0; i < numberOfDaysInView; i++) {
      currentDaysInView.push(moment(viewStartDate).add(i, 'days'));
    }
    return currentDaysInView;
  }, [numberOfDaysInView, viewStartDate]);

  return {
    viewStartDate,
    daysInView,
    handleCalendarNavigation,
    containerRef,
    endOfRange,
  };
};
